import React from 'react';
import ContentLayout from 'components/ContentLayout/SmartLayout';
import Merge from 'components/Sales/Smart/MoveMerge/Merge';
import { getWarehouseCodeFromCache } from 'utils';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

export default function SmartMerge(): JSX.Element {
  return (
    <ContentLayout 
    titleKey="titles.merge" value={getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))}
    // title={`Merge all products from one location to another(W#: ${getWarehouseCodeFromCache(Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)))})`}
    >
      <Merge />
    </ContentLayout>
  );
}
